import {
	DEFAULT_FIONA_EMBED_PARAMS,
	EMBED_ACCESS_TOKENS,
	EMBED_COMPANY_UUIDS,
	EMBED_PARTNERS,
	EMBED_PRODUCTS
} from 'parameters/embeds'
import { urlSerialize } from 'lib'
import { EmbedQueryParameters } from 'components/vendor/MultiProductWidget/types'
import { applyFionaCreditExperiment } from 'services/ExperimentService/buckets'

const approvedUrlParams = ['results', 'step', 'app.purpose', 'featureFlags']

interface Props {
	partner: string
	product: string
	config: Partial<EmbedQueryParameters>
}

type ClientTags = { [key: string]: string }

const extractClientTags = (): ClientTags => {
	const urlParams = new URLSearchParams(window.location.search)
	const tagParams = {} as { [key: string]: string }
	urlParams.forEach((value, key) => {
		if (key.indexOf('tag.') === 0 || approvedUrlParams.includes(key)) {
			tagParams[key] = value
		}
	})
	return tagParams
}

const getTokenKey = (partner: string, product: string, tagParams: ClientTags): string => {
	if (partner === EMBED_PARTNERS.FIONA_SLR) return 'student_loan_refinance'
	if (product === EMBED_PRODUCTS.LOAN && tagParams['tag.gad'] != undefined) return 'loan_sem'
	return product
}

const getProductDefaults = (product: string): Partial<EmbedQueryParameters> => {
	switch (product) {
		case EMBED_PRODUCTS.CREDIT_CARD:
			return {
				step: 'intro',
				credit_card_application_type: 'step_by_step',
				credit_card_flow: 'pre-select',
				show_trusted_partners: 'true'
			}
		case EMBED_PRODUCTS.LOAN:
			return {
				// step: 'application'
			}
	}
	return {}
}

export const buildEmbedParameters = ({ partner, product, config }: Props): string => {
	const clientTags = extractClientTags()
	const tokenKey = getTokenKey(partner, product, clientTags)
	const credentials = {
		access_token: EMBED_ACCESS_TOKENS[tokenKey],
		company_uuid: EMBED_COMPANY_UUIDS[tokenKey]
	}
	const defaults = getProductDefaults(product)

	const mergedParams: EmbedQueryParameters = {
		...DEFAULT_FIONA_EMBED_PARAMS,
		...defaults,
		...credentials,
		available_products: [product],
		productType: [product],
		partner,
		...config,
		...clientTags
	}

	// TODO: Rip out the experiment by December 2021
	return urlSerialize(applyFionaCreditExperiment(mergedParams))
}
